import React, { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Radio, X, ExternalLink } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");

function useNow() {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  return now;
}

function Unit({ v, l }) {
  return <span className="flex flex-col items-center rounded-md bg-[#0B1020]/70 px-2 py-1 leading-none"><b className="font-mono text-base text-white sm:text-lg">{pad(v)}</b><span className="mt-0.5 text-[9px] uppercase tracking-wider text-[#CBD5E1]">{l}</span></span>;
}

export function LiveBanner() {
  const { siteConfig } = useAuth();
  const b = siteConfig?.live_banner;
  const now = useNow();
  const key = b ? `live-banner-closed-${b.starts_at}` : "";
  const [closed, setClosed] = useState(false);
  useEffect(() => { if (key) { setClosed(sessionStorage.getItem(key) === "1"); } }, [key]);
  if (!b?.enabled || !b.starts_at || closed) return null;
  const start = new Date(b.starts_at).getTime();
  const end = start + (b.duration_minutes || 120) * 60000;
  if (Number.isNaN(start) || now > end) return null;
  const live = now >= start;
  const diff = Math.max(0, Math.floor((start - now) / 1000));
  const close = () => { sessionStorage.setItem(key, "1"); setClosed(true); };
  return (
    <div className="relative z-[60] bg-gradient-to-r from-[#7C3AED] via-[#6D28D9] to-[#0E7490] text-white" data-testid="live-banner">
      <div className="mx-auto flex max-w-container flex-wrap items-center justify-center gap-x-4 gap-y-2 px-10 py-2 sm:justify-between sm:px-6">
        <div className="flex items-center gap-2 text-center sm:text-left">
          <Radio className={`h-4 w-4 shrink-0 ${live ? "animate-pulse text-[#FCA5A5]" : ""}`} />
          <p className="text-sm"><b data-testid="live-banner-title">{live ? `In diretta ora: ${b.title}` : b.title}</b>{b.message && <span className="ml-2 hidden text-[#E9D5FF] md:inline" data-testid="live-banner-message">{b.message}</span>}</p>
        </div>
        <div className="flex items-center gap-3">
          {!live && (
            <div className="flex gap-1" data-testid="live-banner-countdown">
              <Unit v={Math.floor(diff / 86400)} l="gg" /><Unit v={Math.floor((diff % 86400) / 3600)} l="ore" /><Unit v={Math.floor((diff % 3600) / 60)} l="min" /><Unit v={diff % 60} l="sec" />
            </div>
          )}
          {b.link_url && <a href={b.link_url} target="_blank" rel="noopener noreferrer" data-testid="live-banner-link" className="inline-flex items-center gap-1 rounded-full bg-white px-3 py-1 text-xs font-semibold text-[#5B21B6] transition-transform hover:scale-105">{b.link_label || (live ? "Guarda la live" : "Vai alla live")}<ExternalLink className="h-3 w-3" /></a>}
        </div>
      </div>
      <button type="button" onClick={close} aria-label="Chiudi banner" data-testid="live-banner-close" className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-white/80 hover:bg-white/10"><X className="h-4 w-4" /></button>
    </div>
  );
}
